import {Model} from "ords/dist/model/model"

export class RubricColumn extends Model{

    getCellForRow(rowId) {
        for (const cel of this.rubric_cells) {
            if (cel.row_id === rowId) {
                return cel;
            }
        }
        return null;
    }
}

export const RubricColumnConfig = {
    name: 'rubricColumn',
    model: RubricColumn,
    relations: [
        {name: 'rubric_column_options', model_name: 'rubricOption', type: 'hasMany'},
        {name: 'rubric_cells', model_name: 'rubricCell', type: 'hasMany'},
    ]
}
